'use strict';

module.exports = [function () {
        return {
            restrict: 'E',
            template: require('./situationRecordNavBarDetail.html'),
            scope: {
                node: "=",
                destination: "=",
                selectCallBackFn: "="
            },

            controller: require('./navBarDetailCtrl.js'),

            link: function (scope) {
//                scope.selectSituationRecordType = function (node) {
//                    console.log('romina-directive detail: ', node);
//                    scope.selectCallBackFn(node);
//                };
            }
        };
    }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordNavBar/situationRecordNavBarDetail.js
// module id = 265
// module chunks = 0